import { FormBlock } from '@qbe/ads-blocks-forms';
import { BaseToggle as Toggle, Spacer, ToggleProps, Typography } from '@qbe/ads-core';
import React from 'react';

import { simpleQuestionOptionsBoolean } from '~/constants/questions';
import { useAppContent, useAppDispatch, useCoverDetails } from '~/hooks';
import { useTrackOptimizeActivate } from '~/hooks/useTrackOptimizeActivate';
import { updateStampdutyExempted } from '~/slices/coverDetails';

const Stampduty: React.FC = () => {
  const { getJSXContent } = useAppContent({ basePath: 'dsme.coverDetailsBusinessLiability' });

  const { stampdutyExempted } = useCoverDetails();
  const dispatch = useAppDispatch();

  // Tracks the "optimize.activate" event when the component mounts or re-renders.
  // This is used to notify Webtrends (or other analytics tools) for visibility tracking
  // and ensures dynamic content is properly handled.
  useTrackOptimizeActivate();
  return (
    <>
      <Typography>{getJSXContent('content.stampDuty.description')}</Typography>
      <Spacer size="md" />

      <FormBlock preset="toggle">
        <Toggle
          name="stampduty"
          optionList={simpleQuestionOptionsBoolean.map((o): ToggleProps['optionList'][number] => ({
            id: `sd${o.text}`,
            value: o.value.toString(),
            label: o.text,
            onChange: (e) => {
              dispatch(updateStampdutyExempted(e.target.value === 'true'));
            },
            defaultChecked: o.value === stampdutyExempted,
          }))}
          data-track="Are you claiming NSW stamp duty exemption?"
          data-track-value="capture"
        />
      </FormBlock>
    </>
  );
};

export default Stampduty;
